export default "__VITE_ASSET__35e20291__"